import React, { useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';

import { RootState } from 'src/reducers';

import mediator from 'Utilities/mediator';

import { PARTNER_TYPES } from 'Constants/partnerTypes';

import LibreAppWrapper from 'Containers/LibreAppWrapper';

import ManageConsent from 'Components/consent/ManageConsent';
import PageNotFound from 'Components/utility/PageNotFound';

const mapState = ({ nav: { location }, partner: { connected, partners } }: RootState) => {
  const pathValues = location.split('/');
  const id = pathValues[pathValues.length - 1];

  return {
    atManageConsent: !!location.match(/^\/consent\/manage\/[^\/\s]+$/i),
    partner: partners[id] || {},
    connected: connected.find((v) => v.clientId === id),
  };
};

const connector = connect(mapState);

type Props = ConnectedProps<typeof connector>;

const Consent: React.FC<React.PropsWithChildren<Props>> = ({
  partner,
  connected,
  atManageConsent,
}) => {
  // We shouldn't be here if this is not a commercialapi partner
  useEffect(() => {
    if (!atManageConsent) {
      return;
    }

    // This checks the partner type and if it exists
    if (!partner || partner.type !== PARTNER_TYPES.COMMERCIAL_API) {
      mediator.publish('router:redirect', '/');
      return;
    }

    if (!partner.id) {
      mediator.publish('router:redirect', '/');
      return;
    }

    if (connected && connected.clientId) {
      mediator.publish('router:redirect', '/share/' + partner.id);
    }
  }, [atManageConsent, connected, partner]);

  let content: React.ReactNode = <PageNotFound />;

  if (atManageConsent) {
    content = <ManageConsent partner={partner}> </ManageConsent>;
  }

  return (
    <LibreAppWrapper app={partner} appType="partner">
      {content}
    </LibreAppWrapper>
  );
};

export default connector(Consent);
